export default class OwnerModel {
    constructor(data = {}) {
        this.id = data.id;
    }
}
